import React, { Component, Fragment } from "react";
import { Progress, Radio } from "antd";
import _ from "lodash";
import {
	ContentContainer,
	QuestionsContainer,
	LocationTypeTitle,
	StatementTitle,
} from "./../../../StyledComponents";
import Matrix from "./Matrix";
import Inline from "./Inline";

class Content extends Component {
	constructor(props) {
		super(props);
		this.state = {
			condition: props.condition,
		};
	}

	updateConditionStatus(ltN, lN, sN, c, value) {
		this.setState({ condition: value });
		this.props.setConditionStatus(ltN, lN, sN, c, value);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ condition: nextProps.condition });
	}

	render() {
		const {
			locationType,
			location,
			statement,
			ltN,
			lN,
			sN,
			allProducts,
			kpiPage,
			setResponse,
		} = this.props;
		const { condition } = this.state;

		let categories = [];
		// Get products by categories & ranges
		location.categories.map((category, c) => {
			// get families
			let families = [];
			category.families.map((family, f) => {
				// get brands
				let brands = [];
				family.brands.map((brand, b) => {
					// get products
					let products = [];
					allProducts.map((product, p) => {
						if (
							product.categoryId === category.categoryId &&
							product.familyId === family.familyId &&
							product.brandId === brand.brandId
						) {
							for (let i = 0; i < product.ranges.length; i++) {
								if (product.ranges[i].rangeId === family.rangeId) {
									//add product
									const productIndex = _.findIndex(products, {
										ean: product.ean,
									});
									if (productIndex === -1) {
										products.push(product);
									}
									break;
								}
							}
						}
					});

					// push brands
					brands.push({
						...brand,
						products,
					});
				});

				// push families
				families.push({
					...family,
					brands,
				});
			});

			// push categories
			categories.push({
				...category,
				families,
			});
		});

		return (
			<div>
				<div className="p-page-subtitle">
					{locationType.label}{" "}
					<span className="p-txt-ft-s">- {location.positionLabel}</span>
				</div>
				<div className="p-clr-nm p-txt-up p-mrg-bot-s">{statement.label}</div>
				<div>
					{statement.conditions.length > 0
						? /* Display question to test condition to display KPIs (if yes is answered) */
						  statement.conditions.map((condition, c) => {
								return (
									<div className="sContent" key={c}>
										<p>{condition.question}</p>
										<Radio.Group
											value={condition}
											buttonStyle="solid"
											onChange={e =>
												this.updateConditionStatus(
													ltN,
													lN,
													sN,
													c,
													e.target.value
												)
											}
										>
											<Radio.Button id="1" value={true} name="condition">
												Oui
											</Radio.Button>
											<Radio.Button id="0" value={false} name="condition">
												Non
											</Radio.Button>
										</Radio.Group>
									</div>
								);
						  })
						: /*update condition to true?*/ null}
					{/*condition ===*/ true ? (
						<div>
							{(function() {
								switch (statement.displayType) {
									case "matrix":
										return (
											<Matrix
												categories={categories}
												kpis={statement.kpis}
												ltN={ltN}
												lN={lN}
												sN={sN}
												kpiPage={kpiPage}
												setResponse={setResponse}
												statement={statement}
											/>
										);
									case "inline":
										return (
											<Inline
												categories={categories}
												kpis={statement.kpis}
												ltN={ltN}
												lN={lN}
												sN={sN}
												setResponse={setResponse}
												statement={statement}
											/>
										);
									default:
										return null;
								}
							})()}
						</div>
					) : null}
				</div>
			</div>
		);
	}
}

export default Content;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSimulation/surveyStep/SimulatedSurvey/Content/Content.js